import React from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            🎁 MÁS LOS{' '}
            <span className="text-[#F97316]" data-id="element-5">6 BONOS ESTRATÉGICOS</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-9">01</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              Kit Clase Mixta Perfecta
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              Principiantes + avanzados en el mismo turno sin caos.
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">
                $12.000
              </span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-17">02</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              Pack Planilla 365
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              Detectá quién está por abandonar antes de que pase.
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">$9.000</span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-25">03</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              Boxeo Listo Sin Ring
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              Clases de calidad en plazas, garages y espacios chicos.
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$8.000</span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-33">04</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              Entrenador con Autoridad
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              Scripts exactos para dirigir el grupo, corregir rápido y retener.
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">
                $10.000
              </span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-41">05</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              Seguridad & Guanteo Inteligente
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              Guanteo técnico seguro con protocolo y 12 misiones.
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$9.000</span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#1a0f00] border border-[#F97316] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#F97316] mb-1" data-id="element-49">06</div>
            <div className="text-[#F97316] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              12 Clases de Emergencia
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              Tu plan B para días caóticos: pocos alumnos, sin equipo, sin
              energía.
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$8.000</span>
              <span className="bg-[#F97316] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#F97316]/40 rounded-2xl p-6 text-center bg-[#0d0700]" data-id="element-56">
          <p className="text-[#F97316] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            💰 Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$56.000</span>
            <span className="text-[#F97316] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Incluidos siempre en las dos ofertas
            </span>
          </div>
        </div>
      </div>
    </section>;
}